<template>
  <div class="wrapper starter-page d-flex justify-content-center">
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <carousel v-bind:perPage="1">
              <slide>
                <img src="/images/remote-horn/clean.jpg" alt="Remote Horn" class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/gland.jpg" alt="Remote Horn With Cable Gland" class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/1con.jpg" alt="Remote Horn With 4-pin Connector"
                     class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/2con.jpg" alt="Remote Horn With 2x 2-pin Connectors"
                     class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/gland-open.jpg" alt="Remote Horn Open"
                     class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/pcbs.jpg" alt="Remote Horn PCB"
                     class="img-raised"/>
              </slide>
              <slide>
                <img src="/images/remote-horn/custom.jpg" alt="Customized Remote Horn"
                     class="img-raised"/>
              </slide>
            </carousel>
          </div>
          <div class="col-md-6 ml-auto mr-auto">
            <h2 class="title">Remote Horn</h2>
            <!--                        <h5 class="category">Slim-Fit Leather Biker Jacket</h5>-->
            <h2 class="main-price">From {{ formatPrice(pricing.base, false) }}</h2>
            <collapse :active-index="0">
              <collapse-item title="Description">
                <p>Allows the app to control external horn automatically in sync with the selected
                  sequence.</p>

                <b>Features</b>
                <ul>
                  <li>Controls external 12V Horn up to 20A (more via external relay)<br/>
                    <span style="font-size: small;">(let us know if you need 24V version)</span></li>
                  <li>Detects and notifies you via LED and app when
                    <ul>
                      <li>horn is unplugged from the controller</li>
                      <li>output is shorted to ground</li>
                      <li>output is shorted to battery</li>
                    </ul>
                  </li>
                  <li>Built-in repeating sound function (timings configurable via the app)</li>


                </ul>
                <b>Package content</b>
                <ul>
                  <li>1 x Remote horn</li>
                  <li>One of:
                    <ul>
                      <li>1 x Cable Gland, 4 x Fork Terminals</li>
                      <li>1 x 4 pin Male Connector (socket pre-wired)</li>
                      <li>2 x 2 pin Connectors (sockets pre-wired)</li>
                    </ul>
                  </li>
                </ul>
                <b>Extra services</b>
                <ul>
                  <li>Railblaza StarPort connection</li>
                  <li>Ask for more</li>
                </ul>
              </collapse-item>
              <collapse-item title="Specifications">
                <table class="table">
                  <tbody>
                  <tr>
                    <td>Input Voltage</td>
                    <td>6-16V (max 25V with limitations)</td>
                  </tr>
                  <tr>
                    <td>Max Current</td>
                    <td>20A (50A Peak)</td>
                  </tr>
                  <tr>
                    <td>Environment Protection</td>
                    <td>IP66 (when cable gland is sealed properly)</td>
                  </tr>
                  <tr>
                    <td>Size (WxDxH)</td>
                    <td>65.2x74.2x42.93mm (2.57"x2.92"x1.69")</td>
                  </tr>
                  <tr>
                    <td>Weight</td>
                    <td>140g (0.3lb)</td>
                  </tr>
                  </tbody>
                </table>

              </collapse-item>
              <collapse-item title="Installation Instructions">
                <b>Tools & supplies needed</b>
                <ul>
                  <li>Philips Screwdriver</li>
                  <li>Knife</li>
                  <li>Crimp Tool</li>
                  <li>Screws for attachment to the surface</li>
                  <li>Cable</li>
                </ul>
                <b>Installation</b>
                <tabs type="primary">
                  <tab-pane label="Cable Gland">
                    <ol>
                      <li>Unscrew lid</li>
                      <li>Terminate cable with provided fork terminals</li>
                      <li>Cut one of the holes in the box along indentation for cable gland</li>
                      <li>Install cable gland and screw tightly</li>
                      <li>Connect terminals according to markings inside the box (see wiring diagrams
                        below)
                      </li>
                      <li>Connect other side of the cable to the horn</li>
                      <li>Verify wiring</li>
                      <li>Connect to the power</li>
                      <li>Button will flash red, then start blinking blue. If it does not - check wiring
                        again before proceeding
                      </li>
                      <li>Screw lid tight</li>
                      <li>Enable Remote horn in the app by going to Setting -> Horn</li>
                      <li>Allow app access to Bluetooth</li>
                      <li>In a couple of seconds your horn will be listed and you can test it by tapping
                        horn button next to it or
                        horn buttons next to sound timings (which will sound all horns connected)
                      </li>
                    </ol>
                  </tab-pane>
                  <tab-pane label="Connector">
                    <ol>
                      <li>Solder cable to provided male connector<br/>
                        4-pin connector: 1,4 - Ground, 2 - Horn, 3 - 12V<br/>
                        2-pin connectors: Left: 1 - Ground, 2 - Horn, Right: 1 - Ground, 2 - 12V<br/>
                      </li>
                      <li>Cut one of the holes in the box along indentation for cable gland</li>
                      <li>Install cable gland and screw tightly</li>
                      <li>Connect terminals according to markings inside the box (see wiring diagrams
                        below)
                      </li>
                      <li>Connect other side of the cable to the horn</li>
                      <li>Verify wiring</li>
                      <li>Connect to the power</li>
                      <li>Button will flash red, then start blinking blue. If it does not - check wiring
                        again before proceeding
                      </li>
                      <li>Screw lid tight</li>
                      <li>Enable Remote horn in the app by going to Setting -> Horn</li>
                      <li>Allow app access to Bluetooth</li>
                      <li>In a couple of seconds your horn will be listed and you can test it by tapping
                        horn button next to it or
                        horn buttons next to sound timings (which will sound all horns connected)
                      </li>
                    </ol>
                  </tab-pane>
                </tabs>

                <div>
                  <img src="/images/remote-horn/relayed.svg" alt="Circuit with relay"/>
                  <div>Using Existing Relay</div>
                </div>
                <div>
                  <img src="/images/remote-horn/3wires.svg" alt="Circuit with relay"/>
                  <div>3-wire cable</div>
                </div>
                <div>
                  <img src="/images/remote-horn/4wires.svg" alt="Circuit with relay"/>
                  <div>4-wire cable</div>
                </div>

              </collapse-item>
            </collapse>
            <div class="row justify-content-end">
              <n-button type="primary" class="mr-3" @click.native="startOrdering">
                Order Now
              </n-button>
            </div>
          </div>
        </div>
      </div>
    </div>

      <modal :show.sync="ordering" headerClasses="justify-content-center" :showClose="false">
        <h4 slot="header" class="title title-up">Order Details</h4>
        <div id="inputs">
          <div class="row">
            <div class="col-sm-12">
              Please provide details below and we will be in touch soon.<br/>
              <span style="font-size: 0.75em">If you want some special configuration let us know in notes below.</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12" style="height: 20px"></div>
          </div>

          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email"
                      :disabled="sending"/>
            <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
            <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          </md-field>
          <md-autocomplete id="country" v-model="form.country" :md-options="Object.keys(countries)" md-dense :md-fuzzy-search="false" autocomplete="off"
                           :class="getValidationClass('country')" @md-changed="updateShipping">
            <label for="country">Country</label>
            <span class="md-error" v-if="!$v.form.country.required">The country is required</span>
            <span class="md-error" v-else-if="!$v.form.country.validCountry">Invalid country</span>
          </md-autocomplete>

          <div>
            <label>Cable connection</label>
            <md-radio v-model="form.cable" value="gland">Cable Gland (6.0~12.0mm cable)</md-radio>
            <md-radio v-model="form.cable" value="SP20P4" disabled="true">4-pin Connector (25A; 8.0~12.0mm cable) (Out of Stock)
              <span class="badge badge-warning">soldering required!</span>
              ({{
                formatPrice(pricing.cable_options.SP20P4, true)
              }})
            </md-radio>
            <md-radio v-model="form.cable" value="SP13P2x2" disabled="true">2x 2-pin Connectors (13A; 3.0~6.5mm cables) (Out of Stock)
              <span class="badge badge-warning">soldering required!</span> ({{
                formatPrice(pricing.cable_options.SP13P2x2, true)
              }})
            </md-radio>
          </div>

          <div>
            <label>Antenna</label>
            <md-radio v-model="form.antenna" value="trace">Normal range</md-radio>
            <md-radio v-model="form.antenna" value="pcb">Longer range ({{
                formatPrice(pricing.antenna_options.pcb, true)
              }})
            </md-radio>
            <md-radio v-if="form.country === 'Test Island'" v-model="form.antenna" value="testing">Test purchase. You will not receive anything ({{
                formatPrice(pricing.antenna_options.testing, true)
              }})</md-radio>
          </div>


          <div class="row">
            <div class="col-sm-4">Unit Price</div>
            <div class="col-sm-8" style="text-align: right">
              <h4 style="margin-top: 11px; margin-bottom: 11px">
                {{ formatPrice(total, false) }}</h4>
            </div>
          </div>

          <md-field :class="getValidationClass('quantity')">
            <label for="age">Quantity</label>
            <md-input type="number" min="1" max="20" id="quantity" name="quantity" v-model="form.quantity"
                      :disabled="sending"/>
            <span class="md-error" v-if="!$v.form.quantity.required">The quantity is required</span>
            <span class="md-error" v-else-if="!$v.form.quantity.maxValue">Invalid quantity</span>
            <span class="md-error" v-else-if="!$v.form.quantity.minValue">Invalid quantity</span>
          </md-field>

          <div>
            <label>Shipping</label>
            <div v-if="shipping_options != null">
              <div v-if="shipping_options.options.length > 0">
              <md-radio v-for="option in shipping_options.options" :key="option.code" v-model="form.shipping" :value="option.code">
                {{ option.name }} {{ formatPrice(option.price, false) }}
              </md-radio>
              <md-radio v-model="form.shipping" value="none">
                Shipping to be arranged. <br/>Click '{{ order_action }}' to place an order and we will contact you to discuss shipping options.
              </md-radio>
              </div>
              <div v-else>
                <div>Sorry, shipping rate is not available for your order. Please click '{{ order_action }}' and we will contact you to discuss shipping options.</div>
              </div>
            </div>
            <div v-else>
              <div>Please select country above to see available options.</div>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12" style="height: 20px"></div>
          </div>
          <div class="row">
            <div class="col-sm-4">Total<br/><span v-if="shipping_cost === 0">(excl. shipping)</span></div>
            <div class="col-sm-8" style="text-align: right">
              <h4 style="margin-top: 11px; margin-bottom: 11px">
                {{ formatPrice(total_sum, false) }}</h4>
            </div>
          </div>

          <md-field>
            <label>Notes</label>
            <md-textarea v-model="form.notes"></md-textarea>
          </md-field>

        </div>
        <template slot="footer">
          <n-button type="default" @click.native="dismissOrdering">Close</n-button>
          <n-button type="primary" @click.native="validateOrder">{{ order_action }}</n-button>
        </template>
      </modal>

    <modal :show.sync="order_success"
           class="modal-primary"
           :show-close="false"
           header-classes="justify-content-center"
           type="mini">
      <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="now-ui-icons ui-1_check"></i>
      </div>
      <h4>Thank you for ordering Remote Horn. We will contact you soon.</h4>
      <template slot="footer">
        <n-button type="neutral" link @click.native="order_success = false">Close</n-button>
      </template>
    </modal>

    <modal :show="order_error != null"
           class="modal-error"
           :show-close="false"
           header-classes="justify-content-center"
           type="mini">
      <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="now-ui-icons ui-1_simple-remove"></i>
      </div>
      <h4>Sorry, there was an error submitting your request. Please try again later. If error persist, please contact us
        on
        <a href="mailto:order@starttimerapp.com">order@starttimerapp.com</a></h4>
      <div>{{ order_error }}</div>
      <template slot="footer">
        <n-button type="neutral" link @click.native="order_error = null">Close</n-button>
      </template>
    </modal>
  </div>
</template>
<script>
import {Button, Collapse, CollapseItem, Modal} from '@/components';
import {Checkbox, FormGroupInput, DropDown, Switch} from '@/components';
import {Tabs, TabPane} from '@/components'
import {Carousel, Slide} from 'vue-carousel';

import api from '@/api'

import { validationMixin } from 'vuelidate'
import {
  required,
  email,
    maxValue,
    minValue
} from 'vuelidate/lib/validators'



export default {
  name: 'product-page',
  bodyClass: 'product-page',
  mixins: [validationMixin],
  components: {
    Collapse,
    CollapseItem,
    Modal,
    Tabs, TabPane,
    'n-button': Button,
    Carousel,
    Slide,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [DropDown.name]: DropDown,
  },
  computed: {
    total() {
      let price = this.pricing.base
      price += this.pricing.cable_options[this.form.cable]
      price += this.pricing.antenna_options[this.form.antenna]
      return price
    },
    total_sum() {
      return this.total * this.form.quantity + this.shipping_cost
    },
    shipping_cost() {
      if (this.shipping_options != null && this.form.shipping != null) {
        for (let o in this.shipping_options.options) {
          let option = this.shipping_options.options[o]
          if (option.code === this.form.shipping) {
            return option.price
          }
        }
      }
      return 0
    },
    order_action() {
      if (this.shipping_options == null || this.shipping_options.can_checkout === false || this.form.shipping === 'none') {
        return  "Place Order"
      } else {
        return  "Checkout >"
      }
    }
  },
  methods: {
    formatPrice(amount, extra) {
      if (amount === 0 && extra) {
        return ""
      }
      return (extra ? (amount >= 0 ? "+" : "-") : "") + "\u2060NZ$\u2060" + Math.abs(amount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    dismissOrdering() {
      this.ordering = false
    },
    startOrdering() {
      this.ordering = true
    },
    async updatePricing() {
      try {
        this.pricing = (await api.get_prices()).data
      } catch (e) {
        console.log(e.toString())
      }
    },
    async updateShipping() {
      this.shipping_loading = true
      try {
        let countryCode = this.countries[this.form.country]
        if (countryCode != null) {
          if (this.shipping_options_cache[countryCode] !== undefined && this.shipping_options_cache[countryCode][this.form.quantity] !== undefined) {
            this.shipping_options = this.shipping_options_cache[countryCode][this.form.quantity]
          } else {
            this.shipping_options = (await api.get_shipping_rates(countryCode, this.form.quantity,
                this.total)).data
            if (this.shipping_options_cache[countryCode] === undefined) {
                this.shipping_options_cache[countryCode] = {}
            }
            this.shipping_options_cache[countryCode][this.form.quantity] = this.shipping_options
          }
          if (this.shipping_options[this.form.shipping] === undefined) {
            if (this.shipping_options.options.length > 0) {
              this.form.shipping = this.shipping_options.options[0].code
            } else {
              this.form.shipping = null
            }
          }
        } else {
          this.shipping_options = null
        }
      } catch (e) {

        this.shipping_options = null
        console.log(e.toString())
      }
      this.shipping_loading = false
    },
    async order() {
      try {
        this.sending = true
        let result = await api.submit_order(this.form.email, this.countries[this.form.country],
            this.form.cable, this.form.antenna, this.form.notes, this.form.quantity,
            this.form.shipping, this.total, this.shipping_cost, this.total_sum)
        this.order_success = true
        this.order_error = null
        if (result.data.payment_link !== null) {
          window.location.href = result.data.payment_link
        }
      } catch (e) {
        this.order_success = false
        this.order_error = e.toLocaleString()
        console.log(e.toString())
      }
      this.sending = false
      this.dismissOrdering()
    },
    validateOrder () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.order()
      }
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },

  },
  validations: {
    form: {
      country: {
        required,
        function(value) {
          return this.countries[value] != null
        }
      },
      cable: {
        required
      },
      antenna: {
        required
      },
      email: {
        required,
        email
      },
      notes: {

      },
      quantity: {
        required,
        max: maxValue(20),
        min: minValue(1)
      },
    }
  },
  watch: {
    /*'shipping_options'() {
        if ((this.shipping_options == null || this.shipping_options.can_checkout === false) && this.form.shipping !== 'none') {
          this.order_action = "Place Order"
        } else {
          this.order_action = "Checkout >"
        }
    },*/
    'form.quantity'() {
      this.updateShipping()
    }
  },
  data() {
    return {
      // order_action: "Place Order",
      shipping_loading: false,
      shipping_options: null,
      order_success: false,
      order_error: null,
      ordering: false,
      pricing: {
        base: 149,
        cable_options: {'gland': 0, 'SP20P4': 13, 'SP13P2x2': 15},
        antenna_options: {'trace': 0, 'pcb': 10, 'testing': 1},
      },
      availability: {
        base: true,
        cable_options: {'gland': true, 'SP20P4': true, 'SP13P2x2': true},
        antenna_options: {'trace': true, 'pcb': true, 'testing': true},
      },
      sending: false,
      form: {
        email: null,
        country: null,
        cable: 'gland',
        antenna: 'trace',
        notes: '',
        quantity: '1',
        shipping: null
      },
      shipping_options_cache: {},
      countries: {
      "New Zealand": "NZ",
      "Afghanistan": "AF",
      "Åland Islands": "AX",
      "Albania": "AL",
      "Algeria": "DZ",
      "American Samoa": "AS",
      "Andorra": "AD",
      "Angola": "AO",
      "Anguilla": "AI",
      "Antarctica": "AQ",
      "Antigua and Barbuda": "AG",
      "Argentina": "AR",
      "Armenia": "AM",
      "Aruba": "AW",
      "Australia": "AU",
      "Austria": "AT",
      "Azerbaijan": "AZ",
      "Bahamas": "BS",
      "Bahrain": "BH",
      "Bangladesh": "BD",
      "Barbados": "BB",
      "Belarus": "BY",
      "Belgium": "BE",
      "Belize": "BZ",
      "Benin": "BJ",
      "Bermuda": "BM",
      "Bhutan": "BT",
      "Bolivia": "BO",
      "Bonaire, Sint Eustatius and Saba": "BQ",
      "Bosnia and Herzegovina": "BA",
      "Botswana": "BW",
      "Bouvet Island": "BV",
      "Brazil": "BR",
      "British Indian Ocean Territory": "IO",
      "Brunei Darussalam": "BN",
      "Bulgaria": "BG",
      "Burkina Faso": "BF",
      "Burundi": "BI",
      "Cambodia": "KH",
      "Cameroon": "CM",
      "Canada": "CA",
      "Cape Verde": "CV",
      "Cayman Islands": "KY",
      "Central African Republic": "CF",
      "Chad": "TD",
      "Chile": "CL",
      "China": "CN",
      "Christmas Island": "CX",
      "Cocos (Keeling) Islands": "CC",
      "Colombia": "CO",
      "Comoros": "KM",
      "Congo, Republic of the (Brazzaville)": "CG",
      "Congo, the Democratic Republic of the (Kinshasa)": "CD",
      "Cook Islands": "CK",
      "Costa Rica": "CR",
      "Côte d'Ivoire, Republic of": "CI",
      "Croatia": "HR",
      "Cuba": "CU",
      "Curaçao": "CW",
      "Cyprus": "CY",
      "Czech Republic": "CZ",
      "Denmark": "DK",
      "Djibouti": "DJ",
      "Dominica": "DM",
      "Dominican Republic": "DO",
      "Ecuador": "EC",
      "Egypt": "EG",
      "El Salvador": "SV",
      "Equatorial Guinea": "GQ",
      "Eritrea": "ER",
      "Estonia": "EE",
      "Ethiopia": "ET",
      "Falkland Islands (Islas Malvinas)": "FK",
      "Faroe Islands": "FO",
      "Fiji": "FJ",
      "Finland": "FI",
      "France": "FR",
      "French Guiana": "GF",
      "French Polynesia": "PF",
      "French Southern and Antarctic Lands": "TF",
      "Gabon": "GA",
      "Gambia, The": "GM",
      "Georgia": "GE",
      "Germany": "DE",
      "Ghana": "GH",
      "Gibraltar": "GI",
      "Greece": "GR",
      "Greenland": "GL",
      "Grenada": "GD",
      "Guadeloupe": "GP",
      "Guam": "GU",
      "Guatemala": "GT",
      "Guernsey": "GG",
      "Guinea": "GN",
      "Guinea-Bissau": "GW",
      "Guyana": "GY",
      "Haiti": "HT",
      "Heard Island and McDonald Islands": "HM",
      "Holy See (Vatican City)": "VA",
      "Honduras": "HN",
      "Hong Kong": "HK",
      "Hungary": "HU",
      "Iceland": "IS",
      "India": "IN",
      "Indonesia": "ID",
      "Iran, Islamic Republic of": "IR",
      "Iraq": "IQ",
      "Ireland": "IE",
      "Isle of Man": "IM",
      "Israel": "IL",
      "Italy": "IT",
      "Jamaica": "JM",
      "Japan": "JP",
      "Jersey": "JE",
      "Jordan": "JO",
      "Kazakhstan": "KZ",
      "Kenya": "KE",
      "Kiribati": "KI",
      "Korea, Democratic People's Republic of": "KP",
      "Korea, Republic of": "KR",
      "Kuwait": "KW",
      "Kyrgyzstan": "KG",
      "Laos": "LA",
      "Latvia": "LV",
      "Lebanon": "LB",
      "Lesotho": "LS",
      "Liberia": "LR",
      "Libya": "LY",
      "Liechtenstein": "LI",
      "Lithuania": "LT",
      "Luxembourg": "LU",
      "Macao": "MO",
      "Macedonia, Republic of": "MK",
      "Madagascar": "MG",
      "Malawi": "MW",
      "Malaysia": "MY",
      "Maldives": "MV",
      "Mali": "ML",
      "Malta": "MT",
      "Marshall Islands": "MH",
      "Martinique": "MQ",
      "Mauritania": "MR",
      "Mauritius": "MU",
      "Mayotte": "YT",
      "Mexico": "MX",
      "Micronesia, Federated States of": "FM",
      "Moldova": "MD",
      "Monaco": "MC",
      "Mongolia": "MN",
      "Montenegro": "ME",
      "Montserrat": "MS",
      "Morocco": "MA",
      "Mozambique": "MZ",
      "Myanmar": "MM",
      "Namibia": "NA",
      "Nauru": "NR",
      "Nepal": "NP",
      "Netherlands": "NL",
      "New Caledonia": "NC",
      "Nicaragua": "NI",
      "Niger": "NE",
      "Nigeria": "NG",
      "Niue": "NU",
      "Norfolk Island": "NF",
      "Northern Mariana Islands": "MP",
      "Norway": "NO",
      "Oman": "OM",
      "Pakistan": "PK",
      "Palau": "PW",
      "Palestine, State of": "PS",
      "Panama": "PA",
      "Papua New Guinea": "PG",
      "Paraguay": "PY",
      "Peru": "PE",
      "Philippines": "PH",
      "Pitcairn": "PN",
      "Poland": "PL",
      "Portugal": "PT",
      "Puerto Rico": "PR",
      "Qatar": "QA",
      "Réunion": "RE",
      "Romania": "RO",
      "Russian Federation": "RU",
      "Rwanda": "RW",
      "Saint Barthélemy": "BL",
      "Saint Helena, Ascension and Tristan da Cunha": "SH",
      "Saint Kitts and Nevis": "KN",
      "Saint Lucia": "LC",
      "Saint Martin": "MF",
      "Saint Pierre and Miquelon": "PM",
      "Saint Vincent and the Grenadines": "VC",
      "Samoa": "WS",
      "San Marino": "SM",
      "Sao Tome and Principe": "ST",
      "Saudi Arabia": "SA",
      "Senegal": "SN",
      "Serbia": "RS",
      "Seychelles": "SC",
      "Sierra Leone": "SL",
      "Singapore": "SG",
      "Sint Maarten (Dutch part)": "SX",
      "Slovakia": "SK",
      "Slovenia": "SI",
      "Solomon Islands": "SB",
      "Somalia": "SO",
      "South Africa": "ZA",
      "South Georgia and South Sandwich Islands": "GS",
      "South Sudan": "SS",
      "Spain": "ES",
      "Sri Lanka": "LK",
      "Sudan": "SD",
      "Suriname": "SR",
      "Swaziland": "SZ",
      "Sweden": "SE",
      "Switzerland": "CH",
      "Syrian Arab Republic": "SY",
      "Taiwan": "TW",
      "Tajikistan": "TJ",
      "Tanzania, United Republic of": "TZ",
      "Thailand": "TH",
      "Timor-Leste": "TL",
      "Togo": "TG",
      "Tokelau": "TK",
      "Tonga": "TO",
      "Trinidad and Tobago": "TT",
      "Tunisia": "TN",
      "Turkey": "TR",
      "Turkmenistan": "TM",
      "Turks and Caicos Islands": "TC",
      "Tuvalu": "TV",
      "Test Island": "TS",
      "Uganda": "UG",
      "Ukraine": "UA",
      "United Arab Emirates": "AE",
      "United Kingdom": "GB",
      "United States": "US",
      "United States Minor Outlying Islands": "UM",
      "Uruguay": "UY",
      "Uzbekistan": "UZ",
      "Vanuatu": "VU",
      "Venezuela, Bolivarian Republic of": "VE",
      "Vietnam": "VN",
      "Virgin Islands, British": "VG",
      "Virgin Islands, U.S.": "VI",
      "Wallis and Futuna": "WF",
      "Western Sahara": "EH",
      "Yemen": "YE",
      "Zambia": "ZM",
      "Zimbabwe": "ZW",
      }
    }
  },
  mounted() {
    this.updatePricing()
  }
}
</script>
<style scoped lang="scss">
.starter-page {
  min-height: calc(100vh - 159px);
}

.md-radio {
  display: flex;
}
</style>

<style lang="scss">
@import "~@/assets/sass/now-ui-kit/_variables.scss";

.md-menu-content {
  z-index: 10002;
  background-color: white;
}

.md-radio .md-radio-label {
  height: auto;
}

 .md-radio.md-checked .md-radio-container:after {
   background-color: $primary-color;
 }

.VueCarousel-wrapper {
  box-shadow: $box-shadow-raised;
}

.md-radio.md-theme-default.md-checked .md-radio-container {
  border-color: $primary-color;
}
.md-radio.md-checked .md-ripple {
  color: $primary-color;
}
.md-ripple {
  z-index: 10000;
}
.md-radio.md-theme-default .md-radio-container {
  border-color: rgba(0,0,0,.54)
}

.md-field .md-error {
  color: #ff1744;
}

.md-field .md-invalid {
  color: #ff1744;
}

.md-disabled {
  color: #939393
}

</style>
